<template>
  <section class="media-search-section">
    <div class="d-flex">
      <HMSearch class="w-100" v-model="search" />
      <slot name="search-left"></slot>
    </div>
    <div class="row mt-3">
      <div class="col-6">
        <v-select
          :placeholder="$t('MEDIA_LIBRARY.LABEL.ALL_TYPES')"
          :options="fileContentList"
          v-model="fileContentSelected"
          :disabled="fileContentList.length === 1"
        />
      </div>
      <div class="col-6">
        <v-select
          :placeholder="$t('MEDIA_LIBRARY.LABEL.ALL_INSTRUCTORS')"
          :options="instructors"
          label="name"
          code="id"
          v-model="instructorsSelected"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <v-select
          :placeholder="$t('MEDIA_LIBRARY.LABEL.ALL_TAGS')"
          :options="categoriesTags"
          multiple
          label="name"
          code="id"
          v-model="tagsSelected"
        />
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'MediaSearchSection',
  data() {
    return {
      search: '',
      fileContentSelected: this.selectedType,
      instructorsSelected: null,
      tagsSelected: [],
    };
  },
  props: {
    value: {
      required: true,
    },
    allowedTypes: {
      type: Array,
      default: () => ['application', 'video', 'audio'],
    },
    selectedType: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState('mediaLibrary', ['instructors']),
    ...mapGetters('mediaLibrary', ['media', 'categoriesTags']),
    query() {
      return {
        q: this.search ? this.search : undefined,
        fileType: this.fileContentSelected?.code,
        instructor: this.instructorsSelected?.id,
        options: this.tagsSelected.map(option => option.id).join(','),
      };
    },
    fileContentList() {
      return [
        {
          label: this.$t('GENERAL.LABEL.DOCUMENTS'),
          code: 'application',
        },
        {
          label: this.$t('GENERAL.LABEL.VIDEO'),
          code: 'video',
        },
        {
          label: this.$t('GENERAL.LABEL.AUDIO'),
          code: 'audio',
        },
      ].filter(type => this.allowedTypes.includes(type.code));
    },
  },
  mounted() {
    this.fileContentSelected = this.fileContentList.find(
      type => type.code === this.selectedType
    );
  },
  watch: {
    query: {
      handler(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
